import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../../commonMeta";

export interface IAcquirerRiskManagementLevelFormMeta {
    bankID: FormInputMeta;
    corporateName: FormInputMeta;
    merchant: FormInputMeta;

    schema: any;
}

const acquirerRiskManagementLevelFormMeta = {} as IAcquirerRiskManagementLevelFormMeta;

acquirerRiskManagementLevelFormMeta.bankID = BankIDInputMeta;

acquirerRiskManagementLevelFormMeta.corporateName = CorporateNameInputMeta;

acquirerRiskManagementLevelFormMeta.merchant = {
  name: "merchant",
  type: "checkbox",
  label: "Merchant",
  placeholder: "",
  validation: yup.boolean().required("Merchant is required")
};

acquirerRiskManagementLevelFormMeta.schema = yup.object().shape(getValidationSchema(acquirerRiskManagementLevelFormMeta));

export default acquirerRiskManagementLevelFormMeta;